Ext.define('SA.Svg', {
    extend: 'SA.Dom',

    statics: {
        createInstance() {
            SA.Svg = new SA.Svg();
        }
    },

    canKebabProperty(property) {
        return property !== 'viewBox';
    },

    createEl(type) {
        return document.createElementNS('http://www.w3.org/2000/svg', type);
    },

    getAttr(el, property) {
        return el.getAttributeNS(null, property);
    },

    getRect(el) {
        var svg, box;

        if (!document.contains(el)) {
            svg = SA.HiddenDom.attach(this.create({type: 'svg', content: el}));
        }

        box = el.getBBox();

        if (svg) {
            el.remove();
            svg.remove();
        }

        return new DOMRect(box.x, box.y, box.width, box.height);
    },

    setAttrImpl(el, property, value) {
        el.setAttributeNS(null, property, value);
    },

    toImageElement(svg) {
        return SA.Image.load(`data:image/svg+xml,${encodeURIComponent(this.toXmlString(svg))}`);
    },

    toXmlString(svg) {
        var svgString = new XMLSerializer().serializeToString(svg);

        return `<?xml version="1.0" encoding="UTF-8" standalone="no"?>${svgString}`;
    },

    translate({el, x, y}) {
        el.transform.baseVal
            .appendItem(this.createEl('svg').createSVGTransform())
            .setTranslate(x, y);

        this.setAttr(el, 'transform-origin', `${x} ${y}`); 
    },

    wrap({backgroundColor, content, margin = 0, ...attributes}) {
        var wrap = this.create({type: 'g', content, transform: `translate(${margin} ${margin})`}),
            wrapRect = this.getRect(wrap),
            width = wrapRect.width + 2 * margin,
            height = wrapRect.height + 2 * margin,
            svgContent = [wrap];

        if (backgroundColor) {
            svgContent.unshift({type: 'rect', fill: backgroundColor, height, width});
        }

        return this.create({type: 'svg', content: svgContent, height, viewBox: `0 0 ${width} ${height}`, width, ...attributes});
    },

    wrapText({style, content, textAnchor, x}) {
        var target = this.createEl('svg'),
            source = SA.Html.create({type: 'div', style, content}),
            result;

        SA.HiddenDom.attach(source);

        result = SA.SvgTextRenderer.renderElement(target, source, {left: x, textAnchor});

        source.remove();

        return result;
    }
}, function(cls) {
    cls.createInstance();
});